import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import * as Cookies from 'es-cookie';
import { withRouter } from 'react-router-dom';
import { isBrowser } from 'react-device-detect';

import SideNavbar from '../components/navbars/SideNavbar';
import NavbarOne from '../components/navbars/NavbarOne';
import Footer from '../components/footer/Footer';
import TimetableBuilder from '../components/Calendar/TimetableBuilder';

class TimetablePage extends Component {
  menuToggler = () => {
    const toggled = Cookies.get('toggle');
    if (toggled === 'wrapper') {
      Cookies.set('toggle', 'wrapper sidebar-enable');
    } else {
      Cookies.set('toggle', 'wrapper');
    }
    this.forceUpdate();
  };

  render() {
    return (
      <div className={Cookies.get('toggle')}>
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />
        </div>
        <div className="main-wrapper">
          <div
            id="sidebar"
            className={
              isBrowser
                ? 'sidebar-menu d-none d-xl-block d-lg-block'
                : 'sidebar-menu d-block d-xl-none d-lg-none'
            }
          >
            <SideNavbar onClick={() => this.menuToggler()} />
          </div>
          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper pt-0">
            <Container fluid>
              <TimetableBuilder />
            </Container>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

export default withRouter(TimetablePage);
